/**
 * Takes `search` from `location.search` and returns the value matching the
 * given param.
 *
 * @param  {string}      search   Search from the URI location
 * @param  {string}      param    Desired param to search
 *
 * @return {string|null}          The value from given param name
 */
export const getSearchParam = (search, param) => {
  const regex = new RegExp(`${param}=([^&]*)`);

  return search.match(regex) && search.match(regex)[1];
};

export const getIn = (obj = {}, path) =>
  path.reduce((xs, x) =>
    (xs && xs[x]) ? xs[x] : null, obj);

export const curriedGetIn = path => obj =>
  path.reduce((xs, x) =>
    (xs && xs[x]) ? xs[x] : null, obj);

export const mapFilter = (obj, fn) =>
  Object
    .keys(obj)
    .reduce((acc, key) =>
      (fn(obj[key]) ? Object.assign({}, acc, { [key]: obj[key] }) : acc),
      {});

export const mapIsEmpty = (obj) => !obj || !Object.keys(obj).length;

export const toArray = (obj) => Object.keys(obj).map((key) => obj[key]);

export const sortByKey = (obj) =>
  Object
    .keys(obj)
    .sort()
    .reduce((acc, key) =>
      Object.assign({}, acc, { [key]: obj[key] }),
      {});

export const isString = s => typeof s === 'string';

export const isNumber = n => typeof n === 'number';

export const isObject = o => o !== null && typeof o === 'object';

export const isBoolean = b => typeof b === 'boolean';

export const isFile = f => f !== null && f instanceof File;

export const toString = (s = "") => s !== null && s.toString && s.toString();

export const toNumber = (n = 0) => n !== null && parseInt(n, 10);

export const toLowerCase = (s = "") =>
  s !== null && s.toLowerCase && s.toLowerCase();

export const toRgba =
  (hex = "#FFFFFF", alpha = .88) =>
    `rgba(
      ${parseInt(hex.substring(1,3),16)},
      ${parseInt(hex.substring(3,5),16)},
      ${parseInt(hex.substring(5,7),16)},
      ${alpha}
    )`;

export const compare = (objA, objB, path, isDesc) => {
  const bandA = objA[path] ? objA[path].toUpperCase() : "";
  const bandB = objB[path] ? objB[path].toUpperCase() : "";

  let comparison = 0;
  if (bandA > bandB) {
    comparison = 1;
  } else if (bandA < bandB) {
    comparison = -1;
  }
  return (isDesc ? -1 : 1)*comparison ;
}

export const encodeBase64 = (stringToEncode) => {
  return new Buffer(stringToEncode).toString('base64');
}



// WEBPACK FOOTER //
// ./src/utils/helpers.js